<app-page-body [class]="'tw-pt-2'" *ngIf="!isVisibleHelpPage">
  <!-- header -->
  <app-page-header
    custom-header
    [title]="pageVocabs + 'title' | translate"
    [loading]="loading"
    [showAddBtn]="false"
    [showAuditBtn]="false"
    (onShowHelp)="onShowHelpPage()"
  >
    <div class="card-toolbar" after-btns>
      @if (!formPageConfig?.isEditMode) {
      <!-- open sendQueue -->
      <page-header-btn
        [name]="
          permissionService.userState()?.isSuperAdmin
            ? 'sendQueue'
            : 'currentUserSendQueue'
        "
        icon="mdi-email-multiple-outline"
        [title]="
          permissionService.userState()?.isSuperAdmin
            ? 'pages.sendQueue.title'
            : 'pages.sendQueue.userTitle'
        "
        btnColor="btn-light"
      ></page-header-btn>

      <!-- open outboxMessages -->
      <page-header-btn
        [name]="
          permissionService.userState()?.isSuperAdmin
            ? 'userOutboxMessages'
            : 'currentUserOutboxMessages'
        "
        icon="mdi-inbox-arrow-up"
        iconSize="mdi-22px"
        [title]="
          permissionService.userState()?.isSuperAdmin
            ? 'pages.outboxMessages.title'
            : 'pages.outboxMessages.userTitle'
        "
        btnColor="btn-light-info"
      ></page-header-btn>
      }
    </div>
  </app-page-header>

  <div class="app-page-content">
    <form [formGroup]="form" autocomplete="off">
      <fieldset class="tw-h-full secondary-panel">
        <!-- smart sms operators -->
        <app-smart-sms-operators
          [isShowToggle]="true"
          (selectedOperator)="selectedOperator = $event"
          [isExistsMCI]="isExistsMCI"
          [isExistsIrancell]="isExistsIrancell"
          [isExistsRightel]="isExistsRightel"
          (operators)="operators = $event"
        ></app-smart-sms-operators>

        <div class="row panels-row tw-mt-3">
          <!-- part 1  messageInformation -->
          <section class="md:tw-w-1/3">
            <fieldset class="tw-h-full">
              <legend class="tw-flex-center">
                <i class="mdi mdi-message-cog tw-ml-2"></i>
                {{ pageVocabs + "legends.smsSetting" | translate }}
              </legend>

              <div
                class="tw-flex tw-justify-between tw-items-center flex-column tw-h-full"
              >
                <div>
                  <!-- alert -->
                  <div class="alert alert-white border tw-mb-5 tw-mt-1">
                    <p class="tw-mb-1 tw-text-justify tw-font-medium">
                      {{
                        "pages.sendingSystem.sendP2PSms.createExcel" | translate
                      }}
                    </p>
                    <p
                      class="text-danger tw-mt-1 tw-mb-0 tw-text-justify tw-font-medium"
                    >
                      *
                      {{
                        "pages.sendingSystem.sendP2PSms.tipsForExcelTable"
                          | translate
                      }}
                    </p>
                  </div>

                  <!-- privateNumberId -->
                  <private-number-select-search
                    label="common.senderNumberId"
                    type="isSmartSendSms"
                    optionValue="number"
                    [smsCp]="SmsCp.MCI"
                    [sendType]="SendTypes.SmartP2P"
                    [useType]="UseTypes.Normal"
                    [control]="form?.get('senderNumberId')"
                    [isShowRefreshBtn]="true"
                    [value]="privateNumber"
                    [isShowSmsCp]="true"
                    (itemChange)="setPrivateNumber($event)"
                  >
                  </private-number-select-search>

                  <!-- p2p-file-uploader -->
                  <div class="tw-mt-2">
                    <file-uploader
                      [label]="'common.file' | translate"
                      [control]="form?.get('inputFile')"
                      [loading]="loading"
                      [progress]="progress"
                      class="tw-w-[275px]"
                      (valueChange)="readFileSmartP2P($event)"
                      (onClearFile)="previewModel = null"
                      acceptFile=".xls,.xlsx,.csv"
                      [maxFileSize]="500"
                      sizeType="mb"
                      (onErrorFile)="showErrorDialog($event)"
                    >
                    </file-uploader>
                  </div>

                  <!-- date time picker -->
                  <div class="tw-mt-2">
                    <app-date-time-picker
                      [config]="directDateTimeConfig"
                      (dateTime)="sendDateTime = $event"
                    >
                    </app-date-time-picker>
                  </div>

                  <!-- description -->
                  <form-textarea
                    class="tw-w-full tw-mt-1"
                    label="common.description"
                    [(value)]="model.description"
                    [control]="form?.get('description')"
                    [rows]="1"
                  >
                  </form-textarea>
                </div>
              </div>
            </fieldset>
          </section>

          <!-- part 2  Guide -->
          <section class="md:tw-w-2/3">
            <!-- (toNumberFieldName)="model.toNumberFieldName=$event" -->
            <app-p2p-sms-body-generator
              class="tw-h-full"
              sendType="smartP2P"
              [columnNames]="importedColList"
              [finalColumnNames]="finalImportedColList"
              [previewModel]="previewModel"
              (pattern)="pattern = $event"
              [loading]="loading"
              (form)="smsBodyGenerator = $event"
            >
            </app-p2p-sms-body-generator>
          </section>

          <div class="tw-w-full">
            <fieldset class="secondary-panel">
              <legend class="tw-flex-center">
                <i class="mdi mdi-earth-box mdi-24px tw-ml-2"></i>
                {{ pageVocabs + "legends.publicMap" | translate }}
              </legend>

              <div class="row">
                <div
                  class="tw-w-full"
                  [ngClass]="{
                    'tw-relative disable-mapboxgl-canvas': !isShowMap
                  }"
                >
                  @if(!isShowMap){
                  <div
                    class="tw-absolute tw-w-full tw-h-full tw-bg-slate-50 dark:tw-bg-slate-800 tw-opacity-40 tw-z-[1] tw-right-0 tw-flex-center"
                  ></div>
                  <span
                    class="tw-absolute tw-text-gray-500 dark:tw-text-white tw-font-extrabold tw-text-xl text-color tw-top-2/4 tw-left-0 tw-right-0 tw-text-center tw-z-[1]"
                    >{{
                      "messages.disableMapInSmartSmsDetail" | translate
                    }}</span
                  >
                  }
                  <app-smart-send-confirmation-map-component
                    #Map
                    (OnLoad)="onMapLoad()"
                    [selectedOperator]="selectedOperator"
                    [ShowPanel]="false"
                    [showDetail]="isPeriodicRequest == false"
                    [isShowRecipients]="isShowMap"
                    [ShowAddToPublicPlace]="true"
                    (OnNextStepClick)="onSubmit()"
                  ></app-smart-send-confirmation-map-component>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </fieldset>
    </form>
  </div>

  <!-- sendLoading -->
  <app-special-loading *ngIf="sendLoading" special-loading type="sending">
  </app-special-loading>
</app-page-body>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="isVisibleHelpPage">
  <app-help-page
    menuTitle="SendP2pSms"
    (hidePage)="onHideHelpPage()"
    [title]="pageVocabs + 'title'"
  >
  </app-help-page>
</ng-container>
